import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { ApolloProvider } from '@apollo/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import ReactDOM from 'react-dom/client';
import App from '~/App.tsx';
import { globalStyles } from '~/shared/styles/global';
import { theme } from '~/shared/styles/theme';
import { ToastProvider } from '~/shared/contexts/ToastContext';
import apolloClient from '~/apollo';
import {
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE,
  ENVIRONMENT_NAME,
  SENTRY_DSN,
} from '~/shared/config';
import { storeAuthReturnPathFromCallback } from '~/shared/utils/authReturnTo';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT_NAME,
});

const enableMocking = async () => {
  if (import.meta.env.MODE !== 'test') {
    return;
  }

  const { worker } = await import('~/tests/mocks/browser');

  return worker.start();
};

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: AUTH0_AUDIENCE,
        }}
        onRedirectCallback={(appState) => {
          storeAuthReturnPathFromCallback(appState);
        }}
      >
        <ApolloProvider client={apolloClient}>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ToastProvider>
                <GlobalStyles styles={globalStyles} />
                <CssBaseline enableColorScheme />
                <App />
              </ToastProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </ApolloProvider>
      </Auth0Provider>
    </React.StrictMode>,
  );
});
